import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { ScfV2Component } from './components/scf-v2/scf-v2.component';
import { RsswaComponent } from './components/rsswa/rsswa.component';
import { UnsavedChangesGuard } from './common/guards/unsaved-changes.guard';
import { EbComponent } from './components/eb/eb.component';
import { TemplateComponent } from './components/template/template.component';
import { RolesComponent } from './components/catalogs/roles/roles.component';
import { PpstbComponent } from './components/ppstb/ppstb.component';
import { KEComponent } from './components/kenable/kenable.component';
import { AbsiBuilderComponent } from './components/absi/absi-builder/absi-builder.component';
import { AbsiComponent } from './components/absi/absi.component';
import { PendingApprovalsV2Component } from './components/pending-approvals-v2/pending-approvals-v2.component';
import { MenuConfigComponent } from './components/menu-config/menu-config.component';
import { RedirectComponent } from './components/redirect/redirect.component';
import { OlogComponent } from './components/olog/olog.component';
import { RedirectGuard } from './common/guards/redirect.guard';
import { BeamlineOverviewComponent } from './components/home/beamline-status/beamline-overview/beamline-overview/beamline-overview.component';
import { PvInfoComponent } from './controls/pvinfo/pvinfo.component';
import { WorkflowComponent } from './components/workflow/workflow.component';
import { AuthenticationGuard } from './common/guards/authentication.guard';
import { LoginComponent } from './components/login/login.component';
import { ApplicationLogsComponent } from './components/application-logs/application-logs.component';

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'login', component: LoginComponent, canDeactivate: [UnsavedChangesGuard, RedirectGuard] },
  { path: 'home', component: HomeComponent, canActivate: [AuthenticationGuard] },
  { path: 'scf', component: ScfV2Component, canActivate: [AuthenticationGuard], canDeactivate: [UnsavedChangesGuard, RedirectGuard] },
  { path: 'rsswa', component: RsswaComponent, canActivate: [AuthenticationGuard], canDeactivate: [UnsavedChangesGuard, RedirectGuard] },
  { path: 'eb2', component: EbComponent, canActivate: [AuthenticationGuard], canDeactivate: [UnsavedChangesGuard, RedirectGuard] },
  { path: 'eb', component: EbComponent, canActivate: [AuthenticationGuard], canDeactivate: [UnsavedChangesGuard, RedirectGuard] },
  { path: 'ppstb', component: PpstbComponent, canActivate: [AuthenticationGuard], canDeactivate: [UnsavedChangesGuard, RedirectGuard] },
  { path: 'template', component: TemplateComponent },
  { path: 'roles', component: RolesComponent, canActivate: [AuthenticationGuard], canDeactivate: [UnsavedChangesGuard, RedirectGuard] },
  { path: 'kenable', component: KEComponent, canActivate: [AuthenticationGuard], canDeactivate: [UnsavedChangesGuard, RedirectGuard] },
  { path: 'ke', component: KEComponent, canActivate: [AuthenticationGuard], canDeactivate: [UnsavedChangesGuard, RedirectGuard] },
  { path: 'absi-builder', component: AbsiBuilderComponent, canActivate: [AuthenticationGuard], canDeactivate: [UnsavedChangesGuard, RedirectGuard] },
  { path: 'absi', component: AbsiComponent, canActivate: [AuthenticationGuard], canDeactivate: [UnsavedChangesGuard, RedirectGuard] },
  { path: 'pending-approvals', component: PendingApprovalsV2Component, canActivate: [AuthenticationGuard], canDeactivate: [RedirectGuard] },
  { path: 'menu-config', component: MenuConfigComponent, canActivate: [AuthenticationGuard], canDeactivate: [UnsavedChangesGuard, RedirectGuard] },
  { path: 'redirect/:serialNo', component: RedirectComponent, },
  { path: 'redirect/:serialNo/:id', component: RedirectComponent, },
  { path: 'olog', component: OlogComponent, canActivate: [AuthenticationGuard] },
  { path: 'beamline-overview', component: BeamlineOverviewComponent, canActivate: [AuthenticationGuard] },
  { path: 'pv-info', component: PvInfoComponent, canActivate: [AuthenticationGuard] },
  { path: 'workflow', component: WorkflowComponent, canActivate: [AuthenticationGuard], canDeactivate: [UnsavedChangesGuard, RedirectGuard] },
  // Exposes the log viewer route; the API independently enforces the Super Administrator role.
  { path: 'application-logs', component: ApplicationLogsComponent, canActivate: [AuthenticationGuard] },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
